var r={exports:{}};export{r as u};
//# sourceMappingURL=updateLocale.js.map
